import React, { useEffect, useRef } from "react";
import styled, { ThemeProvider } from "styled-components";
import { darkTheme } from "./Themes";
import {motion} from 'framer-motion';
import LogoComponent from "./subComponents/LogoComponent";
import SocialIcons from "./subComponents/SocialIcons";
import PowerButton from "./subComponents/PowerButton";
import ParticleComponent from "./subComponents/ParticleComponent";

import { Work } from "../data/WorkData";
import Card from "./subComponents/Card";
import {WorkImg} from "./subComponents/AllSvgs";
import BigTitle from "./subComponents/BigTitle";

const Box = styled.div`
  background-color: ${(props) => props.theme.body};

  height: 400vh;
  position: relative;
  display: flex;
  align-items: center;


`;

const Main = styled(motion.ul)`
position: fixed;
top: 12rem;
left: calc(10rem + 15vw);
height: 40vh;
display: flex;


color:white;
`

const Rotate = styled.span`
display: block;
position: fixed;
right: 1%;
top: 1rem;
width: 80px;
height: 80px;
z-index: 1;
`


const container = {
  hidden: {opacity: 0},
  show:{
    opacity:1,

    transition:{
      staggerChildren:0.5,
      duration: 0.5,
    }
  }
}


function WorkPage() {
  const ref = useRef(null);
  const profile = useRef(null);
  useEffect(() => {
    let element = ref.current;

    const rotate = () =>{
      element.style.transform = `translateX(${-window.pageYOffset}px)`
      profile.current.style.transform = `rotate(` + -window.pageYOffset + `deg)`
    }

    window.addEventListener('scroll', rotate);

    return () => window.removeEventListener('scroll', rotate);


    }, [])


  return (
    <ThemeProvider theme={darkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <ParticleComponent theme="dark"/>
         
        <Main ref={ref} variants={container} initial='hidden' animate='show'>
          {
            Work.map(d =>
              <Card key={d.id} data={d} />
            )
          }
        </Main>
        <Rotate >
        <WorkImg className="workimg" width={120} height={100} fill={darkTheme.text}/>
        </Rotate>
        <BigTitle text="WORK" top='10%' right="20%"/>   
      </Box>
    </ThemeProvider>
  );
}

export default WorkPage;
